import StyledLink from '../StyledLink'
import {
  ACCESS,
  SYSTEM
} from '../routes'
import type { Props } from '../types'

const LinkToAccess = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + SYSTEM + '/' + ACCESS}
  >
    {children}
  </StyledLink>

export default LinkToAccess
